import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import RDFIcon from '../../images/APPIcon.svg';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const APPCard = () => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      icon={RDFIcon}
      note="Minimum investment: $50,000"
      displayNote
      title="Advise me & manage my portfolio"
      subtitle={
        <div>
          Get a portfolio recommendation and ongoing investment management with
          The T. Rowe Price ActivePlus Portfolios
          <sup>&reg;</sup> program
        </div>
      }
      buttonText="Enroll Now"
      buttonFunction={next('app')}
      buttonID={generateGeneralTestID('Card', 'ActivePlusPortfolioButton')}
      cardID={generateGeneralTestID('Card', 'ActivePlusPortfolioCard')}
    />
  );
};

export default APPCard;
